import { faBroom, faFilter } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { Modal } from '@/components/ui/modal.component';
import { ModalCloseButton } from '@/components/ui/modal-close-button/modal-close-button.component';
import { EntityByLetterCount } from '@/types/professional/professional-by-letters.types';
import { alphabet } from '@/utils/consts/alphabet.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface ProfessionalModalByLetterProps {
  open: boolean;
  selectedLetter?: string;
  count: EntityByLetterCount;
  onOpenChange: (isOpen: boolean) => void;
}

export function ProfessionalModalByLetter({
  open,
  selectedLetter = '',
  count,
  onOpenChange,
}: ProfessionalModalByLetterProps) {
  const filteredAlphabet = alphabet.filter((letter) => count[letter] > 0);

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Content
        className="px-3 py-5"
        slotHeader={(
          <div className="flex justify-between gap-[10px] pb-0 items-start w-full">
            <div className="flex items-start gap-[10px] ml-2">
              <Icon icon={faFilter} size="lg" className="text-green-400 mt-1" />
              <span className="font-extrabold text-xl text-gray-900 text-left">
                Filtrar por letra
              </span>
            </div>
            <Modal.Close
              asChild
              className="self-start"
            >
              <ModalCloseButton
                skipInitialFocus
                data-testid={
                  DataTestIdEnum.PROFESSIONALS_CLOSE_MODAL_PROFESSIONAL_BY_LETTER
                }
              />
            </Modal.Close>
          </div>
        )}
      >
        <div className="mt-4 px-2 grid grid-cols-5 gap-x-3 gap-y-3">
          {filteredAlphabet.map((letter) => (
            <div key={letter}>
              <Button
                variant={
                  selectedLetter === letter.toUpperCase()
                    ? 'default'
                    : 'secondary'
                }
                asChild
                data-testid={`button-${letter}--professional-modal-by-letter`}
              >
                <Link
                  prefetch={false}
                  data-testid={DataTestIdEnum.PROFESSIONALS_INDEX_LETTER_BUTTON}
                  href={`/profissionais/por-letra/${letter.toLocaleLowerCase()}/`}
                  className="text-lg"
                >
                  {letter.toUpperCase()}
                </Link>
              </Button>
            </div>
          ))}
        </div>

        {selectedLetter && (
          <div className="mt-6">
            <Button
              variant="text"
              startIcon={faBroom}
              asChild
              data-analytics-event={AnalyticsEnum.CLICK_PROFESSIONAL_INDEX_CLEAR_FILTER}
            >
              <Link
                prefetch={false}
                data-testid={
                  DataTestIdEnum.PROFESSIONALS_INDEX_CLEAR_LETTER_FILTER_BUTTON
                }
                href="/profissionais/"
              >
                Limpar filtro
              </Link>
            </Button>
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
}
